module.exports = __webpack_public_path__ + "static/img/dot-bg.84ce044.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/v1/dot-bg.png
// module id = BF4X
// module chunks = 0